import React, { useCallback, useState } from 'react'
import message from 'antd/lib/message'
import DatePicker from 'antd/lib/date-picker'
import classnames from 'classnames'

import { apiManager } from 'helpers'

import { CloseIcon } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import { OVERLAY } from 'components/AuthModal/styles'
import ProfileImage from 'components/ProfileImage'
import DarkPrimaryButton from 'components/DarkPrimaryButton'

const User = ({ user, label, className }) => (
  <div className={classnames(className)}>
    <div className="text-gray-500 text-lg mb-3 font-medium">{label}</div>
    <div className="flex items-center">
      <ProfileImage className="w-14 h-14 object-cover rounded-full mr-4" src={user.profileImage} />
      <div className="text-xl font-medium">{user.name}</div>
    </div>
  </div>
)

const MatchConfirmationModal = ({ user, profile, show, onClose }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [activatesAt, setActivatesAt] = useState(null)

  const handleMatchConfirmation = useCallback(async () => {
    try {
      setIsSubmitting(true)

      await apiManager.adminCreateMatch({
        userId: user.id,
        profileId: profile.id,
        activatesAt: activatesAt?.format('YYYY-MM-DD'),
      })

      message.success('Match queued successfully', 2.5)
      onClose()
    } catch (error) {
      console.log(error)
      message.destroy()
      message.error(error.message || 'Please try again')
    } finally {
      setIsSubmitting(false)
    }
  }, [user, profile, activatesAt, onClose])

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
      <Modal innerClassName="w-screen max-w-3xl px-10 rounded-t-3xl overflow-y-scroll">
        <div className="relative w-full p-5 max-w-full rounded-2xl bg-white md:p-8 ">
          <button className="bg-transparent text-black absolute top-3 right-4" onClick={onClose}>
            <CloseIcon className="w-4 h-4" />
          </button>
          <div className="text-black text-2xl font-bold font-ownersWide mb-8">
            Set Match Proposal
          </div>
          <div className="flex">
            <User label="First User" user={user} className="mr-9" />
            <User label="Second User" user={profile} />
          </div>
          <div
            className="my-8 h-0.5 w-full"
            style={{
              backgroundColor: '#CCCCCC',
            }}
          />
          <div className="font-semibold text-2xl max-w-lg mb-4">
            When would you like to trigger this Match Recommendation?
          </div>
          <div className="text-emperorGray text-lg mb-4">
            With no date selected, the match will appear on the next upcoming match day
          </div>
          <div className="mb-8">
            <div className="font-semibold text-sm mb-2 underline">Select Date</div>
            <DatePicker
              format="YYYY-MM-DD"
              onChange={setActivatesAt}
              value={activatesAt}
              showToday={true}
              allowClear={true}
              name="activatesAt"
            />
          </div>
          <div className="flex">
            <button className="mr-5 h-14 w-40 border-solid border-2 rounded-xl border-black bg-white font-semibold text-base">
              Cancel
            </button>
            <DarkPrimaryButton
              className="flex-grow"
              loading={isSubmitting}
              onClick={handleMatchConfirmation}
            >
              Confirm Match Recommendation
            </DarkPrimaryButton>
          </div>
        </div>
      </Modal>
    </Overlay>
  )
}

export default MatchConfirmationModal
